import React, { useEffect, useState } from "react";
import styleSheet from "./style.module.scss";
import SyIcon from "../sy-icon";
import { imageProps } from "./sy-slider-interface";

const SySlider = (props: imageProps) => {
  const { image, onSelected, size = "md", value = null, slide = true } = props;

  const [selectedImageData, setSelectedImageData] = useState<any>({
    index: -1,
    image: null,
  });
  const [iconHidden, setIconHidden] = useState<any>("");
  const [slideDirection, setSlideDirection] = useState<"left" | "right">(
    "right"
  );

  const handlePreImage = (index: number) => {
    const preIndex = index - 1;
    if (preIndex >= 0) {
      setSlideDirection("left");
      setIconHidden(preIndex === 0 ? "previous" : "");
      setSelectedImageData({
        index: preIndex,
        image: image[preIndex],
      });
    }
  };

  const handleNextImage = (index: number) => {
    const nextIndex = index + 1;
    if (nextIndex < image.length) {
      setSlideDirection("right");
      setIconHidden(nextIndex === image.length - 1 ? "next" : "");
      setSelectedImageData({
        index: nextIndex,
        image: image[nextIndex],
      });
    }
  };

  useEffect(() => {
    let selectedIndex = value
      ? image.findIndex((data: any) => data.id === value)
      : 0;

    setSelectedImageData({
      index: selectedIndex,
      image: image[selectedIndex],
    });

    setIconHidden(
      selectedIndex === 0
        ? "previous"
        : image.length - 1 === selectedIndex
        ? "next"
        : ""
    );
  }, []);

  useEffect(() => {
    onSelected(selectedImageData.image);
  }, [selectedImageData]);

  return (
    <div className="d-flex align-items-center justify-content-center position-relative pt-3">
      {/* Previous Arrow */}
      {slide && (
        <span onClick={() => handlePreImage(selectedImageData.index)}>
          <SyIcon
            name={size === "md" ? "arrow_back_ios" : "trending_flat"}
            iconColor="white"
            size={size === "md" ? "sm" : "md"}
            className={`${iconHidden === "previous" ? "d-none" : "pointer"} ${
              size === "md" ? "opacity-25" : `${styleSheet.rotate} opacity-75`
            }`}
          />
        </span>
      )}

      {/* Image name */}
      <p className="position-absolute top-0 translate-middle start-50 text-white mb-1 mohave">
        {selectedImageData?.image?.name}
      </p>

      {/* Image Container */}
      <div className={`${styleSheet[size]} mx-4 ${styleSheet.imageWrapper}`}>
        <img
          key={selectedImageData.index} // Force re-render to trigger animation
          src={selectedImageData?.image?.img}
          className={`${styleSheet.image} ${
            slideDirection === "right" ? "slide_in_left" : "slide_in_right"
          }`}
          alt=""
        />
      </div>

      {/* Next Arrow */}
      {slide && (
        <span onClick={() => handleNextImage(selectedImageData.index)}>
          <SyIcon
            name={size === "md" ? "arrow_forward_ios" : "trending_flat"}
            iconColor="white"
            size={size === "md" ? "sm" : "md"}
            className={`${iconHidden === "next" ? "d-none" : "pointer"} ${
              size === "md" ? "opacity-25" : `opacity-75`
            }`}
          />
        </span>
      )}
    </div>
  );
};

export default SySlider;
